import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9sphol8o1vn02ekujn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await response.text();
      const parsed = JSON.parse(responseText);

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会定期为你推送精选内容。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || '订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-accent-50">
      <div className="max-w-xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5 rounded-full bg-accent-100 text-accent-600">
          <i className="ri-mail-send-line text-2xl" />
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          订阅我们的Newsletter
        </h2>
        <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
          每周精选文章、情感故事和社区动态，直接送到你的邮箱。
        </p>

        {status === 'success' ? (
          <div className="mt-6 p-4 bg-accent-100 text-accent-800 rounded-lg text-sm">
            {message}
          </div>
        ) : (
          <form
            data-readdy-form=""
            onSubmit={handleSubmit}
            className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-full focus:outline-none focus:border-accent-400 transition-colors"
            />
            <button
              type="submit"
              className="px-6 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-red-500">{message}</p>
        )}

        <p className="text-xs text-foreground-500 mt-4">
          我们尊重你的隐私，不会发送垃圾邮件。可随时退订。
        </p>
      </div>
    </section>
  );
}